import { IncomingMessage, ServerResponse } from 'http';

import cookie from 'cookie';
import jsCookie from 'js-cookie';

import dayjs from '~/src/common/services/Date';

export const COOKIE_NAME = {
  LDUniqueID: 'launchDarkly-uniqueID',
  LDfirstViewDate: 'launchDarkly-firstView',
  session: 'session',
  friendsAndFamily: 'friends-and-family',
  bypassLanding: 'bypass_landing',
  promoCode: 'promo-code',
} as const;

/**
 * Set a cookie on client side
 * @param cookieName Name of the cookie to get
 * @param expires Date (default: 1 day)
 */
export const setClientCookie = (
  cookieName: keyof typeof COOKIE_NAME,
  value: string,
  expires = dayjs().add(1, 'day').toDate(),
) => {
  return jsCookie.set(COOKIE_NAME[cookieName], value, { expires });
};

/**
 * Get a cookie on server side from an http request
 * @param cookieName Name of the cookie to get
 * @param req Request
 */
export const getServerCookie = (cookieName: string, req: IncomingMessage) => {
  const cookies = cookie.parse(req.headers.cookie ?? '');

  return cookies[cookieName];
};

/**
 * Set a cookie on server side with the server http response
 * @param cookieName Name of the cookie to get
 * @param req Request
 */
export const setServerCookie = (
  {
    name,
    value,
    expires,
  }: {
    name: string;
    value: string;
    expires?: Date;
  },
  res: ServerResponse,
) => {
  const expirationDate = expires ?? dayjs().add(1, 'year').toDate();
  const existingCookies = [res.getHeader('Set-Cookie')]
    .flat()
    .filter((header): header is string => !!header)
    .map(p => p.toString());

  res.setHeader('Set-Cookie', [
    ...existingCookies,
    cookie.serialize(name, value, {
      httpOnly: false,
      expires: expirationDate,
    }),
  ]);
};
